import { logger } from 'redux-logger';
import type { Middleware } from 'redux';
import appReducer from '@/redux/reducers';

import { initialState as auth } from '@/redux/auth/reducer';
import { initialState as user } from '@/redux/user/reducer';
import { initialState as campaign } from '@/redux/campaign/reducer';
import { initialState as challenges } from '@/redux/challenges/reducer';

import { type ConfigureStoreOptions, configureStore } from '@reduxjs/toolkit';

export const preloadedState = { auth, user, campaign, challenges };

const rootStoreConfig: ConfigureStoreOptions = {
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      [import.meta.env.DEV && logger].filter(Boolean) as Middleware[]
    ),

  devTools: import.meta.env.DEV,
  reducer: appReducer,
  preloadedState
};

export default configureStore(rootStoreConfig);
